import { Dialog, DialogContent } from '@mui/material';
import MyLocationIcon from '@mui/icons-material/MyLocation';

import { IActionForProvider } from '../../../Lib/Actions/actions';
import { IMapLocationTracker } from '../types';
import PopupAppBar from '../../Common/PopupAppBar';
import LocationInfo from './LocationInfo';


interface LocationInfoPopupProps {
    action: IActionForProvider<void, void>;
    locationTracker: IMapLocationTracker;
}

const LocationInfoPopup = (props: LocationInfoPopupProps): JSX.Element => {

  return (        
      <Dialog
          fullScreen
          open={props.action.isActive}
          onClose={props.action.cancel}
      >
      <PopupAppBar title="Your Location" icon={<MyLocationIcon/>} onClose={props.action.cancel}/>

      <DialogContent sx={{ backgroundColor: 'black', color: 'white' }}>
        <LocationInfo locationTracker={props.locationTracker} />
      </DialogContent>

    </Dialog>
  );
};

export default LocationInfoPopup;